import { isAuthSubdomain } from '@core/config/authDomain';
import { AppProviders } from './providers';
import { AppRouter } from './router';
import { AuthApp } from './AuthApp';
import { ThemeTestToggle } from './ThemeTestToggle'; // TEMPORARY — remove after validation

/**
 * Root application component.
 *
 * Routes conditionally:
 * - auth.v2.meitre.com (or ?auth=1 in dev) → AuthApp (login/signup only)
 * - {restaurant}.v2.meitre.com             → RestaurantApp (booking flow)
 */
const App = () => {
  if (isAuthSubdomain()) {
    return <AuthApp />;
  }

  return (
    <AppProviders>
      <AppRouter />
      <ThemeTestToggle /> {/* TEMPORARY — remove after validation */}
    </AppProviders>
  );
};

export default App;
